











import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CloseTipIcon extends Vue {
  @Prop({ default: '12' }) readonly width?: string;
  @Prop({ default: '12' }) readonly height?: string;
  @Prop({ default: '#105A40' }) readonly color?: string;
}
